export default {
  // 获取占位广告内容
  getPlAdInfo: '/amc/client/getPlAdInfo',
}